import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import GroupTeacherSideBar from 'PointOfSale/modules/groupTeacher/component/GroupTeacherSideBar';
import * as groupActions from 'PointOfSale/modules/group/state/actions';

class GroupSideBarContainer extends Component {
  toggleSelecedForCheckout = () => {
    const { groupActions, isSelectedForCheckout } = this.props;
    groupActions.toggleCheckoutSelect(!isSelectedForCheckout);
  };

  render() {
    return (
      <React.Fragment>
        <GroupTeacherSideBar
          name={this.props.name}
          toggleSelecedForCheckout={this.toggleSelecedForCheckout}
          isSelectedForCheckout={this.props.isSelectedForCheckout}
        />
      </React.Fragment>
    );
  }
}

GroupSideBarContainer.propTypes = {
  name: PropTypes.string
};

const mapStateToProps = state => ({
  name: state.PointOfSaleState.group.name,
  isSelectedForCheckout: state.PointOfSaleState.group.isSelectedForCheckout
});

const mapDispatchToProps = dispatch => ({
  groupActions: bindActionCreators(groupActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupSideBarContainer);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/group/container/GroupSideBarContainer.js